module.exports = __webpack_public_path__ + "static/img/our-people-our-investment-hero.ae3c237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-our-investment-hero.jpg
// module id = jaLE
// module chunks = 0